const API_BASE_URL = process.env.REACT_APP_MERCHANT_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || 'https://manage.cuscapilab.com/merchant-api/v1'

const TOKEN_KEY = 'token'

export const authStorage = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY)
  },
  setToken(token) {
    localStorage.setItem(TOKEN_KEY, token)
  },
  clearToken(token) {
    localStorage.removeItem(TOKEN_KEY)
  },
}

export class ApiError extends Error {
  constructor(message, status, data) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.data = data
  }
}

const buildUrl = (endpoint, params) => {
  const url = new URL(`${API_BASE_URL}${endpoint}`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        // If value is an array, append each item with the same key
        if (Array.isArray(value)) {
          value.forEach(item => {
            if (item !== undefined && item !== null && item !== '') {
              url.searchParams.append(key, item)
            }
          })
        } else {
          // Otherwise, append as single value
          url.searchParams.append(key, value)
        }
      }
    })
  }

  return url.toString()
}

export async function apiRequest(endpoint, options = {}) {
  const {
    method = 'GET',
    body,
    params,
    headers = {},
    auth = true,
    isFormData = false,
    responseType = 'json',
  } = options

  const token = authStorage.getToken()
  const requestHeaders = {
    Accept: 'application/json',
    ...(!isFormData ? { 'Content-Type': 'application/json' } : {}),
    ...(auth && token ? { Authorization: `Bearer ${token}` } : {}),
    ...headers,
  }
  const response = await fetch(buildUrl(endpoint, params), {
    method,
    headers: requestHeaders,
    body: isFormData ? body : body ? JSON.stringify(body) : undefined,
  })

  let data
  if (responseType === 'text') {
    data = await response.text().catch(() => '')
  } else {
    data = await response.json().catch(() => ({}))
  }

  if (!response.ok) {
    const errorMessage = typeof data === 'string'
      ? data || `Request failed with status ${response.status}`
      : data.message || data.error || `Request failed with status ${response.status}`

    if (response.status === 401 || (data?.code === 'MERCHANT_SUSPENDED' && endpoint !== '/auth/login')) {
      authStorage.clearToken()
      window.location.href = '/login'
      return;
    }

    throw new ApiError(
      errorMessage,
      response.status,
      data,
    )
  }

  return data
}

export default apiRequest
